import React from "react";
import { useNavigate } from "react-router-dom";
import { Settings } from "../../components/Settings";

export function SettingsPage() {
  const navigate = useNavigate();

  const handleLogout = () => {
    navigate("/");
  };

  return <Settings onLogout={handleLogout} />;
}
